import { lazy } from "react";

import EmailGen from "./components/EmailGen";

const EmpSendDemand = lazy(() => import("./components/EmpSendDemand/EmpSendDemand"));
const SettlementMeeting = lazy(() => import("./components/SettlementMeeting/SettlementMeeting"));
const SendAor = lazy(() => import("./components/SendAor/SendAor"));
const PromissoryNoteApproval = lazy(() => import("./components/PromissoryNoteApproval/PromissoryNoteApproval"));

const emailgenRoutes = [
  { path: ":emailId", element: <EmailGen /> },
  { path: ":emailId/emp-demand-recipient-select", element: <EmpSendDemand /> },
  { path: ":emailId/settlement-meeting-select", element: <SettlementMeeting /> },
  { path: ":emailId/defendant-solicitor-select", element: <SendAor /> },
  { path: ":emailId/promissory-note-select", element: <PromissoryNoteApproval /> },
  { path: "*", element: <>404: Page not found</>} // TODO: Build nice 404 component
];

export default emailgenRoutes;
